import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, withLatestFrom, filter } from 'rxjs/operators';
import { Action } from 'redux';
import AppState from '../../state';

import TracPage from '@services/tracpage/types/trac-page';
import { setLocalStorageItem } from '@webapp/utils/localstorage';
import {
  UpdateTracPageDataField,
  UpdateTracPageField,
} from '../action-creators';
import {
  UPDATE_TRAC_PAGE_DATA_FIELD,
  UPDATE_TRAC_PAGE_FIELD,
} from '../actions';
import { NoOp } from '@webapp/store/ui/action-creators';
import { TracPageState } from '../state';

const EDITS_STORAGE_KEY_PREFIX = 'artist_page_edits';

export type StoredTracPageEdits = {
  artistPageDraft: TracPageState['artistPageDraft'];
  artistPageChanges: TracPageState['artistPageChanges'];
  artistPageChangesMap: TracPageState['artistPageChangesMap'];
};

export const storeTracPageEdits = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<
      Action,
      | UpdateTracPageField<TracPage, keyof TracPage>
      | UpdateTracPageDataField<TracPage, keyof TracPage['data']>
    >(UPDATE_TRAC_PAGE_FIELD, UPDATE_TRAC_PAGE_DATA_FIELD),
    withLatestFrom(state$),
    filter(([action]) => action.pageType === 'tracpage'),
    map(([_, state]) => {
      const { artistPageDraft, artistPageChanges, artistPageChangesMap } =
        state.tracpage;

      const toStore: StoredTracPageEdits = {
        artistPageDraft,
        artistPageChanges,
        artistPageChangesMap,
      };

      setLocalStorageItem(
        buildTracPageDraftStorageKey(artistPageDraft.id),
        toStore
      );

      return new NoOp();
    })
  );

export const buildTracPageDraftStorageKey = (pageId: TracPage['id']) => {
  return `${EDITS_STORAGE_KEY_PREFIX}::${pageId}`;
};
